export class SummaryFormatStrings {
    public static readonly VehicleOwnershipFormat = '<b>Name:</b> {0}<br /><b>DL:</b> {1}<br /><b>Mailing Address:</b><br />{2}<br />{3}, {4} {5}';
    // public static readonly VehicleFormat = '<b>Vehicle:</b> {1} {2} {3}<br /><b>Plate:</b> {4}<br /><b>VIN:</b> {0}';
    public static readonly VehicleFormat = '<b>Vehicle:</b> {1} {2} {3}<br /><b>VIN:</b> {0}'; // refer bug 47206
    public static readonly AndRelationFormat = '<br /><br /><b>and</b><br /><br />';
    public static readonly OrRelationFormat = '<br /><br /><b>or</b><br /><br />';
    public static readonly AndOrRelationFormat = '<br /><br /><b>and/or</b><br /><br />';
    public static readonly BlankRelationFormat = '<br /><br />';
}
